<!--<kendo-tabstrip [scrollable]="true" [tabPosition]="position" class="k-tabstrip tab-inventory-usage-report">-->
<!--[tabPosition]="position"-->
<kendo-tabstrip id="k-tabstrip" class="k-tabstrip tab-inventory-usage-report">
  <kendo-tabstrip-tab title="Usage Report" [selected]="true">
    <ng-template kendoTabContent>
      <section>
        <app-sample-request-usage-report></app-sample-request-usage-report>
      </section>
    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab title="Reorder Report">
    <ng-template kendoTabContent>
      <section>
        <app-sample-request-reorder-report></app-sample-request-reorder-report>
      </section>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>
